
import NProgress from "nprogress";

NProgress.configure({ showSpinner: false,  });

export function onStart() {
  NProgress.start();
}

export function onComplete() {
  NProgress.done();
}
